
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { Tree } from './types'

@Component({ name: 'base-tree' })
export default class BaseTree extends Vue {
  @Prop()
  root: Tree
}
